export default __webpack_public_path__ + "static/media/photo3.65ddb28e.jpg";